import React from 'react'
import { useTheme } from '@mui/material'
import { YAxis } from 'recharts'
import { UnitTypes } from 'src/Libs/types'
import { formatYTicks } from 'src/Libs/ai-360/utils'

const YAxisAI360Right: React.FC = () => {
  const theme = useTheme()

  return (
    <YAxis
      yAxisId="right"
      orientation="right"
      axisLine={false}
      tickLine={false}
      tick={{
        dy: -12,
        fontSize: theme.typography.caption.fontSize,
        letterSpacing: theme.typography.caption.letterSpacing,
        fontWeight: theme.typography.caption.fontWeight,
        fill: theme.palette.shades.shade02,
      }}
      width={80}
      mirror={true}
      tickFormatter={value => formatYTicks(value, UnitTypes.watt)}
    />
  )
}

export default YAxisAI360Right
